/* tslint:disable */
/* eslint-disable */
/**
 * Pharma-CMS Popup API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { ContentVisibilityRuleRestDto } from '../models';
import { PopupVisibilityRuleOverviewResultsRestDto } from '../models';
/**
 * PopupVisibilityRuleEndpointsApi - axios parameter creator
 * @export
 */
export const PopupVisibilityRuleEndpointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary REST.API.CMS.POPCV.01 Create a new popup visibility rule.
         * @param {ContentVisibilityRuleRestDto} body 
         * @param {string} popup_id Uniquely identifies the popup.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPopupVisibilityRule: async (body: ContentVisibilityRuleRestDto, popup_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createPopupVisibilityRule.');
            }
            // verify required parameter 'popup_id' is not null or undefined
            if (popup_id === null || popup_id === undefined) {
                throw new RequiredError('popup_id','Required parameter popup_id was null or undefined when calling createPopupVisibilityRule.');
            }
            const localVarPath = `/popup/v1/popup/{popup_id}/visibility_rule`
                .replace(`{${"popup_id"}}`, encodeURIComponent(String(popup_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPCV.05 Delete popup visibility rule.
         * @param {string} popup_rule_id Uniquely identifies the popup visibility rule.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePopupVisibilityRule: async (popup_rule_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'popup_rule_id' is not null or undefined
            if (popup_rule_id === null || popup_rule_id === undefined) {
                throw new RequiredError('popup_rule_id','Required parameter popup_rule_id was null or undefined when calling deletePopupVisibilityRule.');
            }
            const localVarPath = `/popup/v1/visibility_rule/{popup_rule_id}`
                .replace(`{${"popup_rule_id"}}`, encodeURIComponent(String(popup_rule_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPCV.03 Get popup visibility rule.
         * @param {string} popup_rule_id Uniquely identifies the popup visibility rule.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopupVisibilityRule: async (popup_rule_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'popup_rule_id' is not null or undefined
            if (popup_rule_id === null || popup_rule_id === undefined) {
                throw new RequiredError('popup_rule_id','Required parameter popup_rule_id was null or undefined when calling getPopupVisibilityRule.');
            }
            const localVarPath = `/popup/v1/visibility_rule/{popup_rule_id}`
                .replace(`{${"popup_rule_id"}}`, encodeURIComponent(String(popup_rule_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPCV.02 Get an overview of the popup visibility rules.
         * @param {string} popup_id Uniquely identifies the popup.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopupVisibilityRuleOverview: async (popup_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'popup_id' is not null or undefined
            if (popup_id === null || popup_id === undefined) {
                throw new RequiredError('popup_id','Required parameter popup_id was null or undefined when calling getPopupVisibilityRuleOverview.');
            }
            const localVarPath = `/popup/v1/popup/{popup_id}/visibility_rule`
                .replace(`{${"popup_id"}}`, encodeURIComponent(String(popup_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPCV.04 Update popup visibility rule.
         * @param {ContentVisibilityRuleRestDto} body 
         * @param {string} popup_rule_id Uniquely identifies the popup visibility rule.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePopupVisibilityRule: async (body: ContentVisibilityRuleRestDto, popup_rule_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updatePopupVisibilityRule.');
            }
            // verify required parameter 'popup_rule_id' is not null or undefined
            if (popup_rule_id === null || popup_rule_id === undefined) {
                throw new RequiredError('popup_rule_id','Required parameter popup_rule_id was null or undefined when calling updatePopupVisibilityRule.');
            }
            const localVarPath = `/popup/v1/visibility_rule/{popup_rule_id}`
                .replace(`{${"popup_rule_id"}}`, encodeURIComponent(String(popup_rule_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PopupVisibilityRuleEndpointsApi - functional programming interface
 * @export
 */
export const PopupVisibilityRuleEndpointsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary REST.API.CMS.POPCV.01 Create a new popup visibility rule.
         * @param {ContentVisibilityRuleRestDto} body 
         * @param {string} popup_id Uniquely identifies the popup.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPopupVisibilityRule(_axios: AxiosInstance, body: ContentVisibilityRuleRestDto, popup_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PopupVisibilityRuleEndpointsApiAxiosParamCreator(configuration).createPopupVisibilityRule(body, popup_id, x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPCV.05 Delete popup visibility rule.
         * @param {string} popup_rule_id Uniquely identifies the popup visibility rule.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePopupVisibilityRule(_axios: AxiosInstance, popup_rule_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PopupVisibilityRuleEndpointsApiAxiosParamCreator(configuration).deletePopupVisibilityRule(popup_rule_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPCV.03 Get popup visibility rule.
         * @param {string} popup_rule_id Uniquely identifies the popup visibility rule.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPopupVisibilityRule(_axios: AxiosInstance, popup_rule_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentVisibilityRuleRestDto>> {
            const localVarAxiosArgs = await PopupVisibilityRuleEndpointsApiAxiosParamCreator(configuration).getPopupVisibilityRule(popup_rule_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPCV.02 Get an overview of the popup visibility rules.
         * @param {string} popup_id Uniquely identifies the popup.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPopupVisibilityRuleOverview(_axios: AxiosInstance, popup_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PopupVisibilityRuleOverviewResultsRestDto>> {
            const localVarAxiosArgs = await PopupVisibilityRuleEndpointsApiAxiosParamCreator(configuration).getPopupVisibilityRuleOverview(popup_id, x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPCV.04 Update popup visibility rule.
         * @param {ContentVisibilityRuleRestDto} body 
         * @param {string} popup_rule_id Uniquely identifies the popup visibility rule.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePopupVisibilityRule(_axios: AxiosInstance, body: ContentVisibilityRuleRestDto, popup_rule_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PopupVisibilityRuleEndpointsApiAxiosParamCreator(configuration).updatePopupVisibilityRule(body, popup_rule_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PopupVisibilityRuleEndpointsApi - object-oriented interface
 * @export
 * @class PopupVisibilityRuleEndpointsApi
 * @extends {BaseAPI}
 */
export class PopupVisibilityRuleEndpointsApi extends BaseAPI {
    /**
     * 
     * @summary REST.API.CMS.POPCV.01 Create a new popup visibility rule.
     * @param {ContentVisibilityRuleRestDto} body 
     * @param {string} popup_id Uniquely identifies the popup.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopupVisibilityRuleEndpointsApi
     */
     public createPopupVisibilityRule(body: ContentVisibilityRuleRestDto, popup_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return PopupVisibilityRuleEndpointsApiFp(this.configuration).createPopupVisibilityRule(this.axios, body, popup_id, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.POPCV.05 Delete popup visibility rule.
     * @param {string} popup_rule_id Uniquely identifies the popup visibility rule.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopupVisibilityRuleEndpointsApi
     */
     public deletePopupVisibilityRule(popup_rule_id: string, x_dp_customer_code?: string|null, options?: any) {
        return PopupVisibilityRuleEndpointsApiFp(this.configuration).deletePopupVisibilityRule(this.axios, popup_rule_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.POPCV.03 Get popup visibility rule.
     * @param {string} popup_rule_id Uniquely identifies the popup visibility rule.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopupVisibilityRuleEndpointsApi
     */
     public getPopupVisibilityRule(popup_rule_id: string, x_dp_customer_code?: string|null, options?: any) {
        return PopupVisibilityRuleEndpointsApiFp(this.configuration).getPopupVisibilityRule(this.axios, popup_rule_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.POPCV.02 Get an overview of the popup visibility rules.
     * @param {string} popup_id Uniquely identifies the popup.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopupVisibilityRuleEndpointsApi
     */
     public getPopupVisibilityRuleOverview(popup_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return PopupVisibilityRuleEndpointsApiFp(this.configuration).getPopupVisibilityRuleOverview(this.axios, popup_id, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.POPCV.04 Update popup visibility rule.
     * @param {ContentVisibilityRuleRestDto} body 
     * @param {string} popup_rule_id Uniquely identifies the popup visibility rule.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopupVisibilityRuleEndpointsApi
     */
     public updatePopupVisibilityRule(body: ContentVisibilityRuleRestDto, popup_rule_id: string, x_dp_customer_code?: string|null, options?: any) {
        return PopupVisibilityRuleEndpointsApiFp(this.configuration).updatePopupVisibilityRule(this.axios, body, popup_rule_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

}
